var map = {
	"./account.svg": [
		1557,
		70
	],
	"./afternoon.svg": [
		1558,
		71
	],
	"./afterpay.svg": [
		1559,
		72
	],
	"./alert.svg": [
		1560,
		73
	],
	"./apple-store-white.svg": [
		1561,
		75
	],
	"./apple-store.svg": [
		1562,
		74
	],
	"./arrow-diagonal.svg": [
		1563,
		76
	],
	"./arrow-down.svg": [
		1564,
		77
	],
	"./arrow-left.svg": [
		1565,
		78
	],
	"./arrow-pointing-right.svg": [
		1566,
		79
	],
	"./arrow-right.svg": [
		1567,
		80
	],
	"./arrow-up.svg": [
		1568,
		81
	],
	"./ban-icon.svg": [
		1569,
		82
	],
	"./blowdryer.svg": [
		1570,
		83
	],
	"./boxed-calendar.svg": [
		1571,
		84
	],
	"./boxed-check.svg": [
		1572,
		85
	],
	"./boxed-clock.svg": [
		1573,
		86
	],
	"./boxed-drop.svg": [
		1574,
		87
	],
	"./boxed-dropper.svg": [
		1575,
		88
	],
	"./boxed-shop.svg": [
		1576,
		89
	],
	"./calendar-refresh.svg": [
		1577,
		90
	],
	"./calendar.svg": [
		1578,
		91
	],
	"./camera-front.svg": [
		1579,
		92
	],
	"./camera.svg": [
		1580,
		93
	],
	"./caret-down.svg": [
		1581,
		94
	],
	"./caret-rounded.svg": [
		1582,
		95
	],
	"./chair.svg": [
		1583,
		96
	],
	"./chat-2.svg": [
		1584,
		97
	],
	"./chat.svg": [
		1585,
		98
	],
	"./check-circle-empty.svg": [
		1586,
		99
	],
	"./check-circle-filled.svg": [
		1587,
		100
	],
	"./check-circle-solid.svg": [
		1588,
		101
	],
	"./check-circle.svg": [
		1589,
		102
	],
	"./check-icon.svg": [
		1590,
		103
	],
	"./checkmark.svg": [
		1591,
		104
	],
	"./circle-arrow.svg": [
		1592,
		105
	],
	"./circle-camera.svg": [
		1593,
		106
	],
	"./clock.svg": [
		1594,
		107
	],
	"./coily-hair.svg": [
		1595,
		108
	],
	"./color-kit.svg": [
		1596,
		109
	],
	"./color-plus-line-icon.svg": [
		1597,
		110
	],
	"./colorwonder-logo.svg": [
		1598,
		111
	],
	"./comb.svg": [
		1599,
		112
	],
	"./cross-icon.svg": [
		1600,
		113
	],
	"./curly-hair.svg": [
		1601,
		114
	],
	"./cw-check.svg": [
		1602,
		115
	],
	"./cw-message.svg": [
		1603,
		116
	],
	"./dollar-circle.svg": [
		1604,
		117
	],
	"./doordash.svg": [
		1605,
		118
	],
	"./email.svg": [
		1606,
		119
	],
	"./enlarge.svg": [
		1607,
		120
	],
	"./evening.svg": [
		1608,
		121
	],
	"./filters.svg": [
		1609,
		122
	],
	"./gift.svg": [
		1610,
		123
	],
	"./google-play-white.svg": [
		1611,
		125
	],
	"./google-play.svg": [
		1612,
		124
	],
	"./green-check.svg": [
		1613,
		126
	],
	"./hair-color-circles.svg": [
		1614,
		127
	],
	"./hair.svg": [
		1615,
		128
	],
	"./heart-ribbon.svg": [
		1616,
		129
	],
	"./heart.svg": [
		1617,
		130
	],
	"./info-icon.svg": [
		1618,
		131
	],
	"./info.svg": [
		1619,
		132
	],
	"./left-pointing-arrow.svg": [
		1620,
		133
	],
	"./less.svg": [
		1621,
		134
	],
	"./light-bulb.svg": [
		1622,
		135
	],
	"./location.svg": [
		1623,
		136
	],
	"./logout.svg": [
		1624,
		137
	],
	"./mail-circle.svg": [
		1625,
		138
	],
	"./map-circle.svg": [
		1626,
		139
	],
	"./map-marker-base.svg": [
		1627,
		140
	],
	"./map-marker-inverted.svg": [
		1628,
		141
	],
	"./map-marker.svg": [
		1629,
		142
	],
	"./mdsnrd-vertical.svg": [
		1630,
		143
	],
	"./mic-off.svg": [
		1631,
		144
	],
	"./mic.svg": [
		1632,
		145
	],
	"./mirror.svg": [
		1633,
		146
	],
	"./money-back-redesign.svg": [
		1634,
		147
	],
	"./money-back.svg": [
		1635,
		148
	],
	"./money-hand.svg": [
		1636,
		149
	],
	"./more.svg": [
		1637,
		150
	],
	"./morning.svg": [
		1638,
		151
	],
	"./mr-haircolor-logo.svg": [
		1639,
		152
	],
	"./mr-icon-chat.svg": [
		1640,
		153
	],
	"./mr-logo.svg": [
		1641,
		154
	],
	"./mr-mister-logo.svg": [
		1642,
		155
	],
	"./pause.svg": [
		1643,
		156
	],
	"./phone-circle.svg": [
		1644,
		157
	],
	"./phone-handset.svg": [
		1645,
		158
	],
	"./phone.svg": [
		1646,
		159
	],
	"./pin.svg": [
		1647,
		160
	],
	"./plus-circle.svg": [
		1648,
		161
	],
	"./plus.svg": [
		1649,
		162
	],
	"./profile.svg": [
		1650,
		163
	],
	"./ribbon-crown.svg": [
		1651,
		164
	],
	"./ribbon-plus.svg": [
		1652,
		165
	],
	"./roots-hair.svg": [
		1653,
		166
	],
	"./salon.svg": [
		1654,
		167
	],
	"./search-2.svg": [
		1655,
		168
	],
	"./search.svg": [
		1656,
		169
	],
	"./settings.svg": [
		1657,
		170
	],
	"./shampoo-and-conditioner.svg": [
		1658,
		171
	],
	"./shield.svg": [
		1659,
		172
	],
	"./shiny-hair.svg": [
		1660,
		173
	],
	"./shop.svg": [
		1661,
		174
	],
	"./spinner-v2-white.svg": [
		1662,
		176
	],
	"./spinner-v2.svg": [
		1663,
		175
	],
	"./star-octagon-filled.svg": [
		1664,
		177
	],
	"./star-octagon.svg": [
		1665,
		178
	],
	"./star.svg": [
		1666,
		179
	],
	"./stars-filled.svg": [
		1667,
		180
	],
	"./stars.svg": [
		1668,
		181
	],
	"./straight-hair.svg": [
		1669,
		182
	],
	"./switch.svg": [
		1670,
		183
	],
	"./tag.svg": [
		1671,
		184
	],
	"./tick.svg": [
		1672,
		185
	],
	"./times-circle-solid.svg": [
		1673,
		186
	],
	"./trash.svg": [
		1674,
		187
	],
	"./truck.svg": [
		1675,
		188
	],
	"./trust.svg": [
		1676,
		189
	],
	"./tube-and-bottle.svg": [
		1677,
		190
	],
	"./tube-and-brush.svg": [
		1678,
		191
	],
	"./tube-and-comb.svg": [
		1679,
		192
	],
	"./tube.svg": [
		1680,
		193
	],
	"./unlimited-roots-membership-comb-icon.svg": [
		1681,
		194
	],
	"./video-camera-light.svg": [
		1682,
		195
	],
	"./video-chat.svg": [
		1683,
		196
	],
	"./video-off.svg": [
		1684,
		197
	],
	"./video.svg": [
		1685,
		198
	],
	"./waving-hand.svg": [
		1686,
		199
	],
	"./wavy-hair.svg": [
		1687,
		200
	],
	"./x-rounded.svg": [
		1688,
		201
	],
	"./zoom-in.svg": [
		1689,
		202
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1091;
module.exports = webpackAsyncContext;